<script setup lang="ts">

import { useGameStore } from "@/stores/gameStore.ts";
import SmallModel from '@/components/Interface/Modal/ModelSizes/SmallModel.vue'
import FormSelect from '@/components/Elements/Forms/FormSelect.vue'
import { useFleetStore } from '@/stores/fleetStore.ts'
import Backend from '@/models/backend.ts'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore();
const fleetStore = useFleetStore();
const backend = new Backend()

const selectedFleet = ref()

const fleetOptions = computed(() =>
  [...fleetStore.fleets.values()]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((fleet) => ({ value: fleet.id, label: fleet.name }))
)

const selectAndSubmit = (val: string | number) => {
  selectedFleet.value = val
  submit()
}

const submit = () => {
  backend.setFleetForShips(selectedFleet.value,gameStore.modalData).then(()=>{
    gameStore.modalType=''
  })
}

</script>

<template>
  <SmallModel :title="t('modals.assignToFleet.title')">
    <div class="p-2">
      <p class="pb-2 text-subtext">{{ t('modals.assignToFleet.description', { count: gameStore.modalData.length }) }}</p>
    <FormSelect
      :modelValue="selectedFleet"
      @update:modelValue="selectAndSubmit"
      :options="fleetOptions"
      :placeholder="t('modals.assignToFleet.selectPlaceholder')"
    />
      <p class="pt-2 text-subtext">{{ t('modals.assignToFleet.note') }}</p>
    </div>
  </SmallModel>
</template>

<style scoped lang="scss">
.table-container {
  height: 30rem;
  overflow-y: auto;
}
</style>
